<template>
  <div class="wrp">
    <div class="bd">
      <div class="ant-carousel">
        <img class="image" :src="service_logo" />
      </div>
      <div class="paltform">
        <div class="contact1">
          <h3 class="rno-2-section-title">让您的运营更简单</h3>
          <h5 class="rno-2-section-desc">
            用更低的运营成本获得更高的利润空间
          </h5>

          <div
            style="margin: 60px 0 0 0;font-weight:bold;overflow:hidden;"
            class="qq"
          >
            <button style="cursor:pointer;" @click.prevent="handleJump('/register')" class="register">免费注册</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import s1 from "@/assets/images/home/banner99.png"
import service_logo from "@/assets/images/default2/service_logo.png"
import imageWechart from "@/assets/images/default2/wechat_company.png"
import imageQQ from "@/assets/images/default2/wechat_self.png"

export default {
  data() {
    return {
      service_logo: service_logo,
      imageWechart: imageWechart,
      imageQQ: imageQQ,
    }
  },
  methods: {
    handleJump(path) {
      this.$router.push({
        path: path,
      })
    },
  }
}
</script>

<style scoped lang="scss">
.wrp {
  padding: 60px 0 60px;
  background-color: #f4f4f4;
}
.boxHeader {
  margin-bottom: 50px;
  text-align: center;
}
.boxHeader h2 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #181b1c;
  margin-bottom: 20px;
}
.boxHeader p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.bd {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.ant-carousel {
  box-sizing: border-box;
  margin: 0;
  padding: 0 0 0 100px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  list-style: none;
  width: 500px;
  text-align: align;

  .image {
    width: 100%;
  }
}
.bd .paltform {
  width: 480px;
  padding: 50px 0 0 0;
}
.bd .paltform .header {
  line-height: 16px;
  font-size: 16px;
  color: #333;
}
.bd .paltform .paltformBox {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 494px;
}
.bd .paltform .paltformBox .paltformItem {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 235px;
  height: 160px;
  background: #fff;
  border-radius: 4px;
}
.bd .paltform .paltformBox .shopify {
  width: 126px;
  height: 36px;
  margin-bottom: 30px;
  background-size: contain;
  background-image: url(data:image/png;base64,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);
}
.bd .paltform .paltformBox .optBtn {
  width: 100px;
  height: 32px;
  background: linear-gradient(270deg, #146ff4, #4892ff);
  border-radius: 4px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  &:hover {
    background: #8071c9;
    border-color: #8071c9;
  }
}

.bd .paltform .paltformBox .self {
  width: 126px;
  height: 36px;
  margin-bottom: 30px;
  background-size: contain;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGEAAAAcCAYAAABxutG8AAAFN0lEQVRoge2aWYhcRRSGv45jFo3L1RglqISe+BCIMSQREeI+44LgSzBuiBuYByEiE5y4RFQIZoKoqBgdd3FB5zWgZkb0SUQzqCgal25UUERxkqjRUWNaKvwFx/LufTuinR+KmXurbt1b56/6z6lTXVt0/MNUhAg4HzgdOBJYCPwAPA48Beys6kX/N/RUMJ7DgSuBlcAvwMvA68D9wHn6Ow24p9uNnYS8JBwEHAscAcwEakALmAXcCMwHrgGeAXaZ50aBD4A795GQjCwSeoGLgHOABcChwJSYdg3N9hnAT0Hdk8AdnR7IfxlxBvVwErMZWAecChyW0t6R9RDwhkgLsbvbDZ2GJKM6gz4B1KXzbwPf5ehvMfCCJMrix46PZO+iT3Lsy2DK28O29bBBnBytBa6S7n8GPACskP7ngXvuNhnehV4HAltyPhtJ2iJdDwFrSpi3FXNvG7AUuDDmnYOmzVDMs01gxFyPAePAEl33JTyXCyEJLsK5GZgOPKYXr9PH/6mQcyswAZwkJ31AzIuc4W/SCpqu1ZEHfYYAh+GyA4uB72t9SpsooX5YtogjFzPbEWG9RT7MypGL6wdktNVaAY+KgEngPmAesAy4ADhGK+bzhL5dNLVKJL2X8fG+vBTUN4L6tNJnnqup2Nk7IgPVgmINZusLGbIAwjHVLQmnAccBF8sfbJYh0UxwxGw37X+X0VYF9y2WK2L6vkMDSkNkiBlXGY0hsWH6qCfcv1Z1IYFxpTB5Xo7mSCudFL0IvAbMVp1zyK+k9PGq2i+PqZupFZMXvZqNeZEkDwTSNpK/y1REIgT5Dy9x1jFn+YZ/jNGTcAjwJnAXsBE4QwyjjZpz1tcnRFO/AiekvHSxyPi53LhLwzpgT0J/TGd1M+utntv7w6qzPmM8xs80yzhoT8JXwAbgahMZeTg5ObkNY8yVo85DQiNHmzyIAh/R0Mztz4jU6imRlf+7Tf37VRbFtCsEP7N3SpJWa+dbJWbJ2e9NhFEWCivLGKkZRGm+Dx/vt02CXwkzpHXzY9q4XNCOYHXkxf5aBXmJrconRNpfLDGyNG6iH4skOUpCMyDAbr78tztbPpLwfLjaa56EecbhhPhCybmJhM3dbpH0W8wAWyL4m4yBVY24PcFYhnFIkaM1RuvtbI+qWglull6RMludU50KfJjSz9GSszBHtJ/C010Jz4Woyid4eL/QDHa47cAaup6ThH5NAjQJ/jbhp8jIAykfdRRwaUr9Ip0hvAO8FZQtWkVpoWSnUDdG99HRcIHNmi1DQRuPSlaCI+EU/f9+SrvLlb6wKQo3y89UfmiB+poWFIePCmRRe3NuiGo5fFSYI0KzMO9mzZbRhHdUJkeXAF8DtyrxdmJCOxc5nav8kf+AuRmJvTGdsv0bsNIzKDmqAh3xCWcDXwKbdGizURIVYqo2XnmxXcs/Twq8DLL0vS+4Xq882MrgfpnoyCMpOkqDbb+HtB4ZfqtuPqswdaDN/YKLlB4skS4o65ibxvEhKYpMXV1lIqOfpOgIkRN+X3iO0EjYNSfJ2Z5vjktD3ALcWyCiCdFS9nVtyeeLoqnzDgu7ClZUmDuqEmN+VbqfvLQU0YSpict0QrawwIs/FYGV/Y6mG+Dk6A8519mBfj+nVPV1MmxT58wHa7bXlO74WLknF44+DXzb7UYtih5FRC57eoNOwyxcCHoWcLeImKM0hMekDnV2tCFfXQ8nR86BvasDHKdTn2h1LNNZwAZFTJPdbqxOoUehpJvtt8uJLdUGy8X3z2ds4vahXQB/AZ0HQOFLnVBMAAAAAElFTkSuQmCC);
}
.bd .paltform .more {
  width: 494px;
  height: 70px;
  background: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #b7b9bb;
  display: flex;
  align-items: center;
  justify-content: center;
}

.platformImage {
  height: 40px;
}
.paltform {
  color: rgb(73, 52, 178);
}
.tel {
  color: rgb(73, 52, 178);
  font-size: 18px;
  font-weight: bold;
  padding: 16px 0 0 20px;
}
.register {
  background:  rgb(73, 52, 178);
  color: #ffffff;
  border-radius: 6px;
  width: 200px;
  height: 40px;
  line-height: 40px;
  border: 0;
  font-weight: bold;
}
.register:hover{
  opacity: 0.9;
}
</style>
